import A from "i18next";
import { default as zr } from "i18next";
import { initReactI18next as pr, I18nextProvider as vr, useTranslation as mr } from "react-i18next";
import Pe, { useMemo as gr, useEffect as br } from "react";
const Vr = ["en", "hi", "gu"], Q = "en", hr = ["common"], Mr = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "hi", label: "Hindi", nativeLabel: "हिन्दी" },
  { code: "gu", label: "Gujarati", nativeLabel: "ગુજરાતી" }
], Er = { required: "Required", more: "more", submit: "Submit", save: "Save", cancel: "Cancel", filter: "Filter", reset: "Reset", search: "Search", edit: "Edit", delete: "Delete", add: "Add", update: "Update", close: "Close", confirm: "Confirm", back: "Back", next: "Next", finish: "Finish", loading: "Loading...", noData: "No data found", yes: "Yes", no: "No", actions: "Actions", status: "Status", name: "Name", email: "Email", phone: "Phone", date: "Date", description: "Description", viewAll: "View All", myAccount: "My Account", billingAndPlans: "Billing & Plans", helpAndSupport: "Help & Support", takeATour: "Take a Tour", language: "Language", phoneNumberRequired: "Phone number is required", create: "Create", enterMobileNumber: "Enter mobile number", saveAsDraft: "Save as draft", searchPlaceholder: "Search...", noRows: "No rows", salesBot: "SalesBot", admin: "Admin", logout: "Log Out", logoutConfirmation: "Are you sure you want to log out?", yourTimezone: "Your timezone is set to", allDateTimes: "All dates and times are displayed accordingly", exportedSuccessfully: "{{title}} exported successfully!", noDataForExport: "No data received for export.", show: "Show", export: "Export", exporting: "Exporting...", exportData: "Export Data", exportEmailConversationData: "Export Email Conversation Data", exportChatbotConversationData: "Export Chatbot Conversation Data", exportWhatsAppConversationData: "Export WhatsApp Conversation Data", exportInstagramConversationData: "Export Instagram Conversation Data", selectDateRange: "Select Date Range", endDateCannotBeBeforeStartDate: "End Date cannot be before Start Date", noResponseReceived: "No response received." }, yr = {
  common: Er
}, Rr = { required: "आवश्यक", more: "और", submit: "जमा करें", save: "सहेजें", cancel: "रद्द करें", filter: "फ़िल्टर", reset: "रीसेट", search: "खोजें", edit: "संपादित करें", delete: "हटाएं", add: "जोड़ें", update: "अपडेट करें", close: "बंद करें", confirm: "पुष्टि करें", back: "वापस", next: "आगे", finish: "समाप्त करें", loading: "लोड हो रहा है...", noData: "कोई डेटा नहीं मिला", yes: "हाँ", no: "नहीं", actions: "क्रियाएं", status: "स्थिति", name: "नाम", email: "ईमेल", phone: "फ़ोन", date: "तारीख", description: "विवरण", viewAll: "सभी देखें", myAccount: "मेरा खाता", billingAndPlans: "बिलिंग और प्लान", helpAndSupport: "सहायता और समर्थन", takeATour: "टूर लें", language: "भाषा", create: "बनाएं", phoneNumberRequired: "फ़ोन नंबर आवश्यक है", searchPlaceholder: "खोजें...", enterMobileNumber: "मोबाइल नंबर दर्ज करें", saveAsDraft: "ड्राफ्ट के रूप में सहेजें", noRows: "कोई पंक्ति नहीं", salesBot: "सेल्सबॉट", admin: "एडमिन", logout: "लॉग आउट", logoutConfirmation: "क्या आप वाकई लॉग आउट करना चाहते हैं?", yourTimezone: "आपका टाइम ज़ोन यह है", allDateTimes: "सभी तारीखों और समय इस अनुसार प्रदर्शित किए जाएंगे", exportedSuccessfully: "{{title}} सफलतापूर्वक निर्यात किया गया!", noDataForExport: "निर्यात के लिए कोई डेटा प्राप्त नहीं हुआ।", show: "दिखाएँ", export: "निर्यात", exporting: "निर्यात हो रहा है...", exportData: "डेटा निर्यात करें", exportEmailConversationData: "ईमेल वार्तालाप डेटा निर्यात करें", exportChatbotConversationData: "चैटबॉट वार्तालाप डेटा निर्यात करें", exportWhatsAppConversationData: "व्हाट्सएप वार्तालाप डेटा निर्यात करें", exportInstagramConversationData: "इंस्टाग्राम वार्तालाप डेटा निर्यात करें", selectDateRange: "तिथि सीमा चुनें", endDateCannotBeBeforeStartDate: "समाप्ति तिथि प्रारंभ तिथि से पहले नहीं हो सकती", noResponseReceived: "कोई प्रतिक्रिया प्राप्त नहीं हुई।" }, _r = {
  common: Rr
}, Cr = { required: "જરૂરી", more: "વધુ", submit: "સબમિટ કરો", save: "સાચવો", cancel: "રદ કરો", filter: "ફિલ્ટર", reset: "રીસેટ", search: "શોધો", edit: "સંપાદિત કરો", delete: "કાઢો", add: "ઉમેરો", update: "અપડેટ કરો", close: "બંધ કરો", confirm: "પુષ્ટિ કરો", back: "પાછળ", next: "આગળ", finish: "સમાપ્ત કરો", loading: "લોડ થઈ રહ્યું છે...", noData: "કોઈ ડેટા મળ્યો નથી", yes: "હા", no: "ના", actions: "ક્રિયાઓ", status: "સ્થિતિ", name: "નામ", email: "ઈ-મેઈલ", phone: "ફોન", date: "તારીખ", description: "વર્ણન", viewAll: "બધા જુઓ", myAccount: "મારું ખાતું", billingAndPlans: "બિલિંગ અને પ્લાન", helpAndSupport: "મદદ અને સપોર્ટ", takeATour: "ટૂર લો", language: "ભાષા", create: "બનાવો", phoneNumberRequired: "ફોન નંબર આવશ્યક છે", searchPlaceholder: "શોધો...", enterMobileNumber: "મોબાઈલ નંબર દાખલ કરો", saveAsDraft: "ડ્રાફ્ટ તરીકે સાચવો", noRows: "કોઈ હારમાળા નથી", salesBot: "સેલ્સબોટ", admin: "એડમિન", logout: "લૉગ આઉટ", logoutConfirmation: "શું તમે ખરેખર લોગ આઉટ કરવા માંગો છો?", yourTimezone: "તમારો ટાઈમ ઝોન આ છે", allDateTimes: "બધી તારીખો અને સમય આ મુજબ દર્શાવવામાં આવશે", exportedSuccessfully: "{{title}} સફળતાપૂર્વક નિકાસ કરવામાં આવી!", noDataForExport: "નિકાસ માટે કોઈ ડેટા મળ્યો નથી.", show: "બતાવો", export: "નિકાસ કરો", exporting: "નિકાસ થઈ રહી છે...", exportData: "ડેટા નિકાસ કરો", exportEmailConversationData: "ઈમેલ વાર્તાલાપ ડેટા નિકાસ કરો", exportChatbotConversationData: "ચેટબોટ વાર્તાલાપ ડેટા નિકાસ કરો", exportWhatsAppConversationData: "વોટ્સએપ વાર્તાલાપ ડેટા નિકાસ કરો", exportInstagramConversationData: "ઇન્સ્ટાગ્રામ વાર્તાલાપ ડેટા નિકાસ કરો", selectDateRange: "તારીખ શ્રેણી પસંદ કરો", endDateCannotBeBeforeStartDate: "અંતિમ તારીખ પ્રારંભ તારીખ પહેલાં હોઈ શકે નહીં", noResponseReceived: "કોઈ પ્રતિસાદ મળ્યો નથી." }, xr = {
  common: Cr
}, Dr = { filterBy: "Filter By", column: "Column", selectColumn: "Select column", operator: "Operator", selectOperator: "Select operator", value: "Value", selectValue: "Select value", start: "Start", end: "End", applyFilter: "Apply Filter", clear: "Clear", columnError: "Please select a column.", operatorError: "Please select an operator.", rangeError: "Please fill both start and end values.", valueError: "Please enter a value." }, Sr = {
  tableFilterDrawer: Dr
}, Tr = { filterBy: "फ़िल्टर द्वारा", column: "कॉलम", selectColumn: "कॉलम चुनें", operator: "ऑपरेटर", selectOperator: "ऑपरेटर चुनें", value: "मान", selectValue: "मान चुनें", start: "शुरू", end: "अंत", applyFilter: "फ़िल्टर लागू करें", clear: "साफ़ करें", true: "सही", false: "गलत", columnError: "कृपया एक कॉलम चुनें।", operatorError: "कृपया एक ऑपरेटर चुनें।", rangeError: "कृपया शुरू और अंत दोनों मान भरें।", valueError: "कृपया एक मान दर्ज करें।" }, wr = {
  tableFilterDrawer: Tr
}, Pr = { filterBy: "ફિલ્ટર દ્વારા", column: "કોલમ", selectColumn: "કોલમ પસંદ કરો", operator: "ઓપરેટર", selectOperator: "ઓપરેટર પસંદ કરો", value: "મૂલ્ય", selectValue: "મૂલ્ય પસંદ કરો", start: "શરૂઆત", end: "અંત", applyFilter: "ફિલ્ટર લાગુ કરો", clear: "સ્પષ્ટ", true: "સાચું", false: "ખોટું", columnError: "કૃપા કરીને કોલમ પસંદ કરો.", operatorError: "કૃપા કરીને ઓપરેટર પસંદ કરો.", rangeError: "કૃપા કરીને શરૂઆત અને અંત બંને મૂલ્યો ભરો.", valueError: "કૃપા કરીને મૂલ્ય દાખલ કરો." }, Ar = {
  tableFilterDrawer: Pr
}, Z = {
  en: { common: yr, tableFilterDrawer: Sr },
  hi: { common: _r, tableFilterDrawer: wr },
  gu: { common: xr, tableFilterDrawer: Ar }
};
function Or(d) {
  if (!d) return Z;
  const l = {};
  for (const p of Object.keys(Z))
    l[p] = { ...Z[p] ?? {} };
  for (const [p, f] of Object.entries(d))
    l[p] = { ...l[p] ?? {}, ...f };
  return l;
}
function jr(d) {
  if (!d) return [];
  const l = /* @__PURE__ */ new Set();
  for (const p of Object.values(d))
    for (const f of Object.keys(p))
      l.add(f);
  return Array.from(l);
}
function kr(d = Q, l) {
  if (A.isInitialized)
    return A.language !== d && A.changeLanguage(d), A;
  const p = [...hr, ...jr(l)], f = Or(l);
  return A.use(pr).init({
    resources: f,
    lng: d,
    fallbackLng: Q,
    defaultNS: "common",
    ns: p,
    interpolation: { escapeValue: !1 },
    react: { useSuspense: !1 }
  }), A;
}
var M = { exports: {} }, F = {};
var Se;
function Fr() {
  if (Se) return F;
  Se = 1;
  var d = Pe, l = /* @__PURE__ */ Symbol.for("react.element"), p = /* @__PURE__ */ Symbol.for("react.fragment"), f = Object.prototype.hasOwnProperty, N = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, L = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(_, v, S) {
    var h, y = {}, C = null, $ = null;
    S !== void 0 && (C = "" + S), v.key !== void 0 && (C = "" + v.key), v.ref !== void 0 && ($ = v.ref);
    for (h in v) f.call(v, h) && !L.hasOwnProperty(h) && (y[h] = v[h]);
    if (_ && _.defaultProps) for (h in v = _.defaultProps, v) y[h] === void 0 && (y[h] = v[h]);
    return { $$typeof: l, type: _, key: C, ref: $, props: y, _owner: N.current };
  }
  return F.Fragment = p, F.jsx = O, F.jsxs = O, F;
}
var I = {};
var Te;
function Ir() {
  return Te || (Te = 1, process.env.NODE_ENV !== "production" && (function() {
    var d = Pe, l = /* @__PURE__ */ Symbol.for("react.element"), p = /* @__PURE__ */ Symbol.for("react.portal"), f = /* @__PURE__ */ Symbol.for("react.fragment"), N = /* @__PURE__ */ Symbol.for("react.strict_mode"), L = /* @__PURE__ */ Symbol.for("react.profiler"), O = /* @__PURE__ */ Symbol.for("react.provider"), _ = /* @__PURE__ */ Symbol.for("react.context"), v = /* @__PURE__ */ Symbol.for("react.forward_ref"), S = /* @__PURE__ */ Symbol.for("react.suspense"), h = /* @__PURE__ */ Symbol.for("react.suspense_list"), y = /* @__PURE__ */ Symbol.for("react.memo"), C = /* @__PURE__ */ Symbol.for("react.lazy"), $ = /* @__PURE__ */ Symbol.for("react.offscreen"), ee = Symbol.iterator, Ae = "@@iterator";
    function Oe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = ee && e[ee] || e[Ae];
      return typeof r == "function" ? r : null;
    }
    var T = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        je("error", e, t);
      }
    }
    function je(e, r, t) {
      {
        var a = T.ReactDebugCurrentFrame, i = a.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var s = t.map(function(o) {
          return String(o);
        });
        s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var ke = !1, Fe = !1, Ie = !1, Ne = !1, Le = !1, re;
    re = /* @__PURE__ */ Symbol.for("react.module.reference");
    function $e(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === f || e === L || Le || e === N || e === S || e === h || Ne || e === $ || ke || Fe || Ie || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === y || e.$$typeof === O || e.$$typeof === _ || e.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function We(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function R(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case f:
          return "Fragment";
        case p:
          return "Portal";
        case L:
          return "Profiler";
        case N:
          return "StrictMode";
        case S:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case _:
            var r = e;
            return te(r) + ".Consumer";
          case O:
            var t = e;
            return te(t._context) + ".Provider";
          case v:
            return We(e, e.render, "ForwardRef");
          case y:
            var a = e.displayName || null;
            return a !== null ? a : R(e.type) || "Memo";
          case C: {
            var i = e, s = i._payload, o = i._init;
            try {
              return R(o(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, j = 0, ae, ne, oe, ie, se, le, ue;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function Be() {
      {
        if (j === 0) {
          ae = console.log, ne = console.info, oe = console.warn, ie = console.error, se = console.group, le = console.groupCollapsed, ue = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        j++;
      }
    }
    function Ye() {
      {
        if (j--, j === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, e, {
              value: ae
            }),
            info: x({}, e, {
              value: ne
            }),
            warn: x({}, e, {
              value: oe
            }),
            error: x({}, e, {
              value: ie
            }),
            group: x({}, e, {
              value: se
            }),
            groupCollapsed: x({}, e, {
              value: le
            }),
            groupEnd: x({}, e, {
              value: ue
            })
          });
        }
        j < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = T.ReactCurrentDispatcher, q;
    function W(e, r, t) {
      {
        if (q === void 0)
          try {
            throw Error();
          } catch (i) {
            var a = i.stack.trim().match(/\n( *(at )?)/);
            q = a && a[1] || "";
          }
        return `
` + q + e;
      }
    }
    var G = !1, B;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      B = new Ve();
    }
    function fe(e, r) {
      if (!e || G)
        return "";
      {
        var t = B.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      G = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = U.current, U.current = null, Be();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (b) {
              a = b;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (b) {
              a = b;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (b) {
            a = b;
          }
          e();
        }
      } catch (b) {
        if (b && a && typeof b.stack == "string") {
          for (var n = b.stack.split(`
`), g = a.stack.split(`
`), u = n.length - 1, c = g.length - 1; u >= 1 && c >= 0 && n[u] !== g[c]; )
            c--;
          for (; u >= 1 && c >= 0; u--, c--)
            if (n[u] !== g[c]) {
              if (u !== 1 || c !== 1)
                do
                  if (u--, c--, c < 0 || n[u] !== g[c]) {
                    var E = `
` + n[u].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && B.set(e, E), E;
                  }
                while (u >= 1 && c >= 0);
              break;
            }
        }
      } finally {
        G = !1, U.current = s, Ye(), Error.prepareStackTrace = i;
      }
      var P = e ? e.displayName || e.name : "", D = P ? W(P) : "";
      return typeof e == "function" && B.set(e, D), D;
    }
    function Me(e, r, t) {
      return fe(e, !1);
    }
    function Ue(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function Y(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return fe(e, Ue(e));
      if (typeof e == "string")
        return W(e);
      switch (e) {
        case S:
          return W("Suspense");
        case h:
          return W("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            return Me(e.render);
          case y:
            return Y(e.type, r, t);
          case C: {
            var a = e, i = a._payload, s = a._init;
            try {
              return Y(s(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var k = Object.prototype.hasOwnProperty, de = {}, pe = T.ReactDebugCurrentFrame;
    function V(e) {
      if (e) {
        var r = e._owner, t = Y(e.type, e._source, r ? r.type : null);
        pe.setExtraStackFrame(t);
      } else
        pe.setExtraStackFrame(null);
    }
    function qe(e, r, t, a, i) {
      {
        var s = Function.call.bind(k);
        for (var o in e)
          if (s(e, o)) {
            var n = void 0;
            try {
              if (typeof e[o] != "function") {
                var g = Error((a || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw g.name = "Invariant Violation", g;
              }
              n = e[o](r, o, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (u) {
              n = u;
            }
            n && !(n instanceof Error) && (V(i), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, o, typeof n), V(null)), n instanceof Error && !(n.message in de) && (de[n.message] = !0, V(i), m("Failed %s type: %s", t, n.message), V(null));
          }
      }
    }
    var Ge = Array.isArray;
    function J(e) {
      return Ge(e);
    }
    function Je(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function ze(e) {
      try {
        return ve(e), !1;
      } catch {
        return !0;
      }
    }
    function ve(e) {
      return "" + e;
    }
    function me(e) {
      if (ze(e))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Je(e)), ve(e);
    }
    var ge = T.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, be, he;
    function He(e) {
      if (k.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (k.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, r) {
      typeof e.ref == "string" && ge.current;
    }
    function Qe(e, r) {
      {
        var t = function() {
          be || (be = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function er(e, r) {
      {
        var t = function() {
          he || (he = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var rr = function(e, r, t, a, i, s, o) {
      var n = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: l,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: s
      };
      return n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(n, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(n, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    };
    function tr(e, r, t, a, i) {
      {
        var s, o = {}, n = null, g = null;
        t !== void 0 && (me(t), n = "" + t), Xe(r) && (me(r.key), n = "" + r.key), He(r) && (g = r.ref, Ze(r, i));
        for (s in r)
          k.call(r, s) && !Ke.hasOwnProperty(s) && (o[s] = r[s]);
        if (e && e.defaultProps) {
          var u = e.defaultProps;
          for (s in u)
            o[s] === void 0 && (o[s] = u[s]);
        }
        if (n || g) {
          var c = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          n && Qe(o, c), g && er(o, c);
        }
        return rr(e, n, g, i, a, ge.current, o);
      }
    }
    var z = T.ReactCurrentOwner, Ee = T.ReactDebugCurrentFrame;
    function w(e) {
      if (e) {
        var r = e._owner, t = Y(e.type, e._source, r ? r.type : null);
        Ee.setExtraStackFrame(t);
      } else
        Ee.setExtraStackFrame(null);
    }
    var K;
    K = !1;
    function H(e) {
      return typeof e == "object" && e !== null && e.$$typeof === l;
    }
    function ye() {
      {
        if (z.current) {
          var e = R(z.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      return "";
    }
    var Re = {};
    function nr(e) {
      {
        var r = ye();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function _e(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = nr(r);
        if (Re[t])
          return;
        Re[t] = !0;
        var a = "";
        e && e._owner && e._owner !== z.current && (a = " It was passed a child from " + R(e._owner.type) + "."), w(e), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), w(null);
      }
    }
    function Ce(e, r) {
      {
        if (typeof e != "object")
          return;
        if (J(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            H(a) && _e(a, r);
          }
        else if (H(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = Oe(e);
          if (typeof i == "function" && i !== e.entries)
            for (var s = i.call(e), o; !(o = s.next()).done; )
              H(o.value) && _e(o.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === y))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = R(r);
          qe(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !K) {
          K = !0;
          var i = R(r);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            w(e), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), w(null);
            break;
          }
        }
        e.ref !== null && (w(e), m("Invalid attribute `ref` supplied to `React.Fragment`."), w(null));
      }
    }
    var xe = {};
    function De(e, r, t, a, i, s) {
      {
        var o = $e(e);
        if (!o) {
          var n = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (n += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var g = ar();
          g ? n += g : n += ye();
          var u;
          e === null ? u = "null" : J(e) ? u = "array" : e !== void 0 && e.$$typeof === l ? (u = "<" + (R(e.type) || "Unknown") + " />", n = " Did you accidentally export a JSX literal instead of a component?") : u = typeof e, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, n);
        }
        var c = tr(e, r, t, i, s);
        if (c == null)
          return c;
        if (o) {
          var E = r.children;
          if (E !== void 0)
            if (a)
              if (J(E)) {
                for (var P = 0; P < E.length; P++)
                  Ce(E[P], e);
                Object.freeze && Object.freeze(E);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ce(E, e);
        }
        if (k.call(r, "key")) {
          var D = R(e), b = Object.keys(r).filter(function(dr) {
            return dr !== "key";
          }), X = b.length > 0 ? "{key: someKey, " + b.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xe[D + X]) {
            var fr = b.length > 0 ? "{" + b.join(": ..., ") + ": ...}" : "{}";
            m(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, X, D, fr, D), xe[D + X] = !0;
          }
        }
        return e === f ? ir(c) : or(c), c;
      }
    }
    function sr(e, r, t) {
      return De(e, r, t, !0);
    }
    function lr(e, r, t) {
      return De(e, r, t, !1);
    }
    var ur = lr, cr = sr;
    I.Fragment = f, I.jsx = ur, I.jsxs = cr;
  })()), I;
}
var we;
function Nr() {
  return we || (we = 1, process.env.NODE_ENV === "production" ? M.exports = Fr() : M.exports = Ir()), M.exports;
}
var Lr = Nr();
const Ur = ({
  children: d,
  language: l = Q,
  appResources: p
}) => {
  const f = gr(
    () => kr(l, p),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return br(() => {
    f.language !== l && f.changeLanguage(l);
  }, [l, f]), /* @__PURE__ */ Lr.jsx(vr, { i18n: f, children: d });
}, $r = (d) => {
  const { t: l, i18n: p, ready: f } = mr(d);
  return { t: l, i18n: p, ready: f };
}, qr = () => $r("common");
export {
  Q as DEFAULT_LANGUAGE,
  Ur as I18nProvider,
  Mr as LANGUAGE_OPTIONS,
  hr as SHARED_NAMESPACES,
  Vr as SUPPORTED_LANGUAGES,
  zr as i18n,
  kr as initI18n,
  $r as useAppTranslation,
  qr as useCommonTranslation
};
